import { ButtonProps as BaseButtonProps, cn, Spinner, useButton } from '@heroui/react';
import { forwardRef } from 'react';

export interface DropdownTriggerButtonProps extends BaseButtonProps {
    startContent?: React.ReactNode;
    endContent?: React.ReactNode;
}

const DropdownTriggerButton = forwardRef<HTMLButtonElement, DropdownTriggerButtonProps>(
    (props, ref) => {
        const {
            domRef,
            children,
            startContent,
            endContent,
            spinnerSize,
            spinner = <Spinner color="current" size={spinnerSize} />,
            spinnerPlacement,
            isLoading,
            getButtonProps,
        } = useButton({
            ref,
            variant: 'flat',
            ...props,
        });

        return (
            <button
                ref={domRef}
                {...getButtonProps()}
                className={cn(
                    'inline-flex items-center justify-between gap-2',
                    'min-w-[200px] px-3 py-2',
                    'bg-default-100 hover:bg-default-200',
                    'data-[pressed=true]:bg-default-200',
                    'rounded-lg',
                    'transition-colors',
                    props.className,
                )}
            >
                <div className="flex items-center gap-2">
                    {startContent}
                    {isLoading && spinnerPlacement === 'start' && spinner}
                    <span className="flex-1">{children}</span>
                </div>
                <div className="flex items-center">
                    {isLoading && spinnerPlacement === 'end' && spinner}
                    {endContent}
                </div>
            </button>
        );
    },
);

DropdownTriggerButton.displayName = 'DropdownTriggerButton';

export default DropdownTriggerButton;
